import CartService from "../services/cart.service";
import log from "loglevel";

const cartForms = [...document.querySelectorAll(".add-to-cart")];

cartForms.forEach((form) => {
  const qtyField = form.Quantity;
  const variantField = form.ProductReference;
  const priceText = form.querySelector(".price") || form.closest("tr")?.previousElementSibling.querySelector(".price");
  const skuText = form.querySelector(".sku-info") || form.closest("tr")?.previousElementSibling.querySelector(".sku-info") || document.querySelector(".sku-info");
  variantField.addEventListener("change", () => {
    var variantOptions = variantField.options[variantField.selectedIndex];
    if (priceText) {
      var price = variantOptions.dataset.price;
      if (price != null) {
        priceText.innerText = price;
      }
    }
    if (skuText) {
      var sku = variantOptions.dataset.sku;
      if (sku != null) {
        skuText.innerText = sku;
      }
    }
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    let formData = getFormJSON(form);
    log.info("Adding to cart:", formData);

    CartService.AddToCart(formData).then(() => {
      qtyField.value = null;
    });
  });
});

const getFormJSON = (form) => {
  const data = new FormData(form);
  return Array.from(data.keys()).reduce((result, key) => {
    result[key] = data.get(key);
    return result;
  }, {});
};
